import { preferencesReducer } from 'app-components/flux/preferences';
import { handleActions } from 'redux-actions';
import { PreferencesStore } from './types';

const initialState = new PreferencesStore();

export const reducer = (state, action) => {
  const state1 = handleActions({}, initialState)(state, action);
  const state2 = preferencesReducer(state1, action);
  return state2;
};

export const REDUCER_KEY = 'preferencesStore';
export default reducer;
